import { useReducer } from 'react';
import handleResponse from './handleResponse';
import { reducer, status } from './fileUploaderReducer';
import {
  uploadingAction,
  uploadedAction,
  notUploadedAction,
  removeItemAction,
  deletingAction,
  notDeletedAction,
} from './fileUploaderActions';
import createId from './createId';

export const dispatchMiddleware = (createFile, deleteFile, dispatch) => {
  const uploading = uploadingAction(dispatch);
  const uploaded = uploadedAction(dispatch);
  const notUploaded = notUploadedAction(dispatch);
  const deleting = deletingAction(dispatch);
  const notDeleted = notDeletedAction(dispatch);
  const removeItem = removeItemAction(dispatch);
  const queueId = createId();

  return (action) => {
    const { type, value } = action;
    switch (type) {
      case status.FILE_SELECTED:
        handleResponse(
          createFile(value),
          (data) => uploaded(queueId, data),
          (error) => notUploaded(queueId, error)
        );
        return uploading(queueId, value);
      case status.DELETE_CLICKED:
        handleResponse(
          deleteFile(value.fileId),
          () => removeItem(value.queueId),
          (error) => notDeleted(value.queueId, error)
        );
        return deleting(value.queueId);
      default:
        return dispatch(action);
    }
  };
};

const useQueue = (initialFileQueue, createFile, deleteFile, middleware) => {
  const [fileQueue, reducerDispatch] = useReducer(reducer, initialFileQueue);

  const dispatch = middleware(createFile, deleteFile, reducerDispatch);
  const removeItem = removeItemAction(dispatch);

  const onChange = (event, files) => {
    files.forEach((file) => {
      dispatch({
        type: status.FILE_SELECTED,
        value: file,
      });
    });
  };

  const deleteRemoteFile = (queueId, fileId) =>
    dispatch({
      type: status.DELETE_CLICKED,
      value: {
        fileId,
        queueId,
      },
    });

  return { fileQueue, onChange, deleteRemoteFile, removeItem };
};

export default useQueue;
